<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
  <kendo-panelbar #panelbar>
    <kendo-panelbar-item 
                         [expanded]="true">
      <ng-template kendoPanelBarItemTitle>
        <span>{{submittalLbl.selectionsPanelLbl?submittalLbl.selectionsPanelLbl:selectionFormLabel.selectionsPanelLbl}}</span>
        <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
              *ngIf="!selectionDetails.isSelectionPanelValid && selectionDetails.isSubmitted"></span>
        <span class="k-icon k-i-check-circle k-i-checkmark-circle"
              *ngIf="selectionDetails.isSelectionPanelValid && selectionDetails.isSubmitted"
              style="color:green;font-weight:600"></span>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <form [formGroup]="selectionForm">
          <div class="row m-top">
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="lbl">
                  {{submittalLbl.projectNameLbl?submittalLbl.projectNameLbl:selectionFormLabel.projectNameLbl}}
                  <span class="requiredField">*</span>
                </label>
                <input type="text" kendoTextBox formControlName="projectName"
                       class="kendoInput" (blur)="validateSelectionForm()" [ngClass]="{'borderRed':selectionDetails.isEmptyProjectName && selectionDetails.isSubmitted}" />
              </div>
              <div class="form-group">
                <label class="lbl">{{submittalLbl.projectLocationLbl?submittalLbl.projectLocationLbl:selectionFormLabel.projectLocationLbl}}<span class="requiredField">*</span></label>
                <input type="text" kendoTextBox formControlName="projectLocation"
                       class="kendoInput" (blur)="validateSelectionForm()" [ngClass]="{'borderRed':selectionDetails.isEmptyProjectLocation && selectionDetails.isSubmitted}" />
              </div>
              <div class="form-group">
                <div class="mb-3">
                  <kendo-switch formControlName="aluminiumCare" name="toggle" onLabel="Yes" offLabel="No">
                  </kendo-switch>
                  <label class="k-checkbox-label" for="ch1">{{submittalLbl.aluminumCareLbl?submittalLbl.aluminumCareLbl:selectionFormLabel.aluminumCareLbl}}</label>
                </div>

                <div class="mb-3">
                  <kendo-switch formControlName="architectureDetails" name="toggle" (valueChange)="showDetails()" onLabel="Yes" offLabel="No">
                  </kendo-switch>
                  <label class="k-checkbox-label" for="ch2">
                    {{submittalLbl.architecturalDetailsLbl?submittalLbl.architecturalDetailsLbl:selectionFormLabel.architecturalDetailsLbl}}
                  </label>
                </div>

                <div class="mb-3">
                  <kendo-switch formControlName="customerVarificationLetter" name="toggle" onLabel="Yes" offLabel="No">
                  </kendo-switch>
                  <label class="k-checkbox-label" for="ch3">
                    {{submittalLbl.customerVerficationLetterLbl?submittalLbl.customerVerficationLetterLbl:selectionFormLabel.customerVerficationLetterLbl}}
                  </label>
                </div>

                <div class="mb-3">
                  <kendo-switch formControlName="preSubmittalDocument" name="toggle" onLabel="Yes" (click)="showLeedMuiltiSelect()" offLabel="No">
                  </kendo-switch>
                  <label class="k-checkbox-label" for="ch4">
                    {{submittalLbl.leedPreSubmittalDocumentationLbl?submittalLbl.leedPreSubmittalDocumentationLbl:selectionFormLabel.leedPreSubmittalDocumentationLbl}}
                  </label>
                </div>
              </div>
              <div *ngIf="showLeedMultiSelectDropdown">
                <div class="form-group">
                  <label class="lbl">
                    {{submittalLbl.leedSubmittalDocumentationLbl?submittalLbl.leedSubmittalDocumentationLbl:selectionFormLabel.leedSubmittalDocumentationLbl}}
                  </label>
                  <kendo-multiselect [data]="leedPreSubmittalDocumentData" class="kendoInput" formControlName="leedPreSubmittalDocument" [valueField]="'value'" [textField]="'name'">
                    <ng-template kendoMultiSelectItemTemplate let-dataList>
                      <span class="template">{{dataList.name}}</span>
                    </ng-template>
                  </kendo-multiselect>
                </div>
                <div class="form-group">
                  <label class="lbl">
                    {{submittalLbl.productDeclareLbl?submittalLbl.productDeclareLbl:selectionFormLabel.productDeclareLbl}}
                  </label>
                  <kendo-multiselect [data]="productDeclareData" class="kendoInput" formControlName="productDeclare" [valueField]="'value'" [textField]="'name'">
                    <ng-template kendoMultiSelectItemTemplate let-dataList>
                      <span class="template">{{dataList.name}}</span>
                    </ng-template>
                  </kendo-multiselect>
                </div>
                <div class="form-group">
                  <label class="lbl">
                    {{submittalLbl.environmentalProductLBL?submittalLbl.environmentalProductLBL:selectionFormLabel.environmentalProductLBL}}
                  </label>
                  <kendo-multiselect [data]="EnvironmentalProductsData" class="kendoInput" formControlName="environmentalProduct" [valueField]="'value'" [textField]="'name'">
                    <ng-template kendoMultiSelectItemTemplate let-dataList>
                      <span class="template">{{dataList.name}}</span>
                    </ng-template>
                  </kendo-multiselect>
                </div>
                <div class="form-group">
                  <label class="lbl">
                    {{submittalLbl.cradleLBL?submittalLbl.cradleLBL:selectionFormLabel.cradleLBL}}
                  </label>
                  <kendo-multiselect [data]="cradleData" class="kendoInput" formControlName="cradle" [valueField]="'value'" [textField]="'name'">
                    <ng-template kendoMultiSelectItemTemplate let-dataList>
                      <span class="template">{{dataList.name}}</span>
                    </ng-template>
                  </kendo-multiselect>
                </div>
                <div class="form-group">
                  <label class="lbl">
                    {{submittalLbl.materialTransparencyLBL?submittalLbl.materialTransparencyLBL:selectionFormLabel.materialTransparencyLBL}}
                  </label>
                  <kendo-multiselect [data]="MaterialTransparencyData" class="kendoInput" formControlName="materialTransparency" [valueField]="'value'" [textField]="'name'">
                    <ng-template kendoMultiSelectItemTemplate let-dataList>
                      <span class="template">{{dataList.name}}</span>
                    </ng-template>
                  </kendo-multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="lbl">
                  {{submittalLbl.sampleWarrantiesLbl?submittalLbl.sampleWarrantiesLbl:selectionFormLabel.sampleWarrantiesLbl}}
                </label>
                <kendo-multiselect [data]="sampleWarrantiesData" class="kendoInput" formControlName="sampleWarranty" [valueField]="'value'" [textField]="'name'">
                  <ng-template kendoMultiSelectItemTemplate let-dataList>
                    <span class="template">{{dataList.name}}</span>
                  </ng-template>
                </kendo-multiselect>
              </div>
              <div class="form-group">
                <kendo-switch formControlName="testReport" (valueChange)="showReports()" name="toggle" onLabel="Yes" offLabel="No">
                </kendo-switch>
                <label class="k-checkbox-label" for="ch5">

                  {{submittalLbl.testReportsLbl?submittalLbl.testReportsLbl:selectionFormLabel.testReportsLbl}}
                </label>
              </div>
              
              <div class="form-group">
                <label class="lbl">{{submittalLbl.paintDocumentsLbl?submittalLbl.paintDocumentsLbl:selectionFormLabel.paintDocumentsLbl}}</label>
                <kendo-multiselect [data]="paintDocumentsData" class="kendoInput" formControlName="paintDocument" [valueField]="'value'" [textField]="'name'">
                  <ng-template kendoMultiSelectItemTemplate let-dataList>
                    <span class="template">{{dataList.name}}</span>
                  </ng-template>
                </kendo-multiselect>
              </div>
            </div>
            <div class="col-sm-3"></div>
          </div>
        </form>
        <div class="d-flex justify-content-center col-xs-12 col-sm-12">
          <button kendoButton primary="true" class="continue-button m-3"
                  (click)="continueToNextPanel()">
            {{submittalLbl.continueLbl?submittalLbl.continueLbl:continueLbl}}
          </button>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item 
                         [expanded]="false" *ngIf="showDetailsPanel">
      <!--submittalLbl.architecturalDetailsTitleLbl?submittalLbl.architecturalDetailsTitleLbl:-->
      <ng-template kendoPanelBarItemTitle>
        <span>{{detailsPanellabel.title}}</span>
        <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
              *ngIf="!showDetail.isSelectionPanelValid && showDetail.isSubmitted"></span>
        <span class="k-icon k-i-check-circle k-i-checkmark-circle"
              *ngIf="showDetail.isSelectionPanelValid && showDetail.isSubmitted"
              style="color:green;font-weight:600"></span>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="row m-top">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6" *ngFor="let item of multiSelectList;let i=index">
                <div class="form-group">
                  <label class="lbl">{{item.category}}</label>
                  <kendo-multiselect [data]="item.filteredmultiSelectData"
                                     textField="subCategory"
                                     valueField="submittalLevel2key"
                                     [virtual]="true"
                                     [filterable]="true"
                                     (focus)="handleCategoryFilter($event,item)"
                                     (filterChange)="handleCategoryFilter($event,item)"
                                     class="kendoInput"
                                     [(ngModel)]="item.selectedValues"
                                     (valueChange)="multiSelectChange($event,i,item)"
                                     (blur)="multiSelectLeave()">
                    <ng-template kendoMultiSelectItemTemplate let-dataList>
                      <span class="template">{{dataList.subCategory}}</span>
                    </ng-template>
                  </kendo-multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-2"></div>
        </div>
        <div class="d-flex justify-content-center col-xs-12 col-sm-12">
          <button kendoButton primary="true" class="continue-button m-3"
                  (click)="continueToGenerateSubmittal()">
            {{continueLbl}}
          </button>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item 
                         [expanded]="false" *ngIf="showReportsPanel">
      <ng-template kendoPanelBarItemTitle>
        <span>{{submittalLbl.testReportsPanelLbl?submittalLbl.testReportsPanelLbl:testReport.testReportsPanelLbl}}</span>
        <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
              *ngIf="!testReportData.isTestReportPanelValid && testReportData.isTestReportContinue"></span>
        <span class="k-icon k-i-check-circle k-i-checkmark-circle"
              *ngIf="testReportData.isTestReportPanelValid && testReportData.isTestReportContinue"
              style="color:green;font-weight:600"></span>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="m-10">
          <div class="row m-top">
            <div [ngClass]="languageCode==='eng'?'col-sm-2':'col-sm-4'">
              <div class="form-group">
                <label class="lbl">
                  {{submittalLbl.productTypeLbl?submittalLbl.productTypeLbl:testReport.productTypeLbl}}
                  <span class="requiredField">*</span>
                </label>
                <kendo-multiselect [data]="productTypeData" [popupSettings]="{popupClass:'freight-popup'}"
                                   textField="subCategory" valueField="submittalLevel2key" [filterable]="true"  (focus)="handleProductTypeFilter($event)"
                                   (filterChange)="handleProductTypeFilter($event)"
                                   [(ngModel)]="testReportData.productType"
                                   class="kendoInput"
                                   [ngClass]="{'borderRed':testReportData.isEmptyProductType && testReportData.isSubmitted}"
                                   (blur)="productTypeLeave()">
                  <ng-template kendoMultiSelectItemTemplate let-dataList>
                    <span class="template">{{dataList.subCategory}}</span>
                  </ng-template>
                </kendo-multiselect>
              </div>
            </div>
            <div [ngClass]="languageCode==='eng'?'col-sm-2':'col-sm-4'">
              <div class="form-group">
                <label class="lbl">{{submittalLbl.selectTestReportCategoryLbl?submittalLbl.selectTestReportCategoryLbl:testReport.selectTestReportCategoryLbl}}</label>
                <kendo-multiselect [data]="categoryData"  [popupSettings]="{popupClass:'freight-popup'}"
                                   textField="testReportCategory" valueField="submittalLevel3key"
                                   [(ngModel)]="testReportData.category"
                                   class="kendoInput" (blur)="categoryLeave()"
                                   [filterable]="true"  (focus)="handleTestCategoryFilter($event)"
                                   (filterChange)="handleTestCategoryFilter($event)">
                  <ng-template kendoMultiSelectItemTemplate let-dataList>
                    <span class="template">{{dataList.testReportCategory}}</span>
                  </ng-template>
                </kendo-multiselect>
              </div>
            </div>
            <div [ngClass]="languageCode==='eng'?'col-sm-2':'col-sm-4'">
              <div class="form-group">
                <label class="lbl" [for]="subCategoryLabel">
                  {{submittalLbl.selectTestReportSubCategoryLbl?submittalLbl.selectTestReportSubCategoryLbl:testReport.selectTestReportSubCategoryLbl}}
                </label>
                <kendo-multiselect [data]="subCategoryData" [popupSettings]="{popupClass:'freight-popup'}"
                                   textField="productOptTested" valueField="submittalLevel4key"
                                   [(ngModel)]="testReportData.subCategory"
                                   class="kendoInput"
                                   (blur)="subCategoryleave()"
                                    [filterable]="true"  (focus)="handleTestSubCategoryFilter($event)"
                                   (filterChange)="handleTestSubCategoryFilter($event)">
                  <ng-template kendoMultiSelectItemTemplate let-dataList>
                    <span class="template">{{dataList?.testReportSubCategory}}</span>
                  </ng-template>
                </kendo-multiselect>
              </div>
            </div>
            <div [ngClass]="languageCode==='eng'?'col-sm-5':'col-sm-8'">
              <div class="form-group">
                <label class="lbl" [for]="subCategoryLabel">{{submittalLbl.testTypeLbl?submittalLbl.testTypeLbl:testReport.testTypeLbl}}</label>
                <kendo-multiselect [data]="testTypeData" [popupSettings]="{popupClass:'freight-popup'}"
                                   textField="productOptTested" valueField="submittalLevel4key"
                                   [(ngModel)]="testReportData.testType" class="kendoInput"  [filterable]="true" (focus)="handleTestTypeFilter($event)"
                                   (filterChange)="handleTestTypeFilter($event)">
                  <ng-template kendoMultiSelectItemTemplate let-dataList>
                    <span class="template">{{dataList.productOptTested}}</span>
                  </ng-template>
                </kendo-multiselect>
              </div>
            </div>
            <div [ngClass]="languageCode==='eng'?'col-sm-1':'col-sm-4'">
              <button kendoButton primary="true" class="m-3 btn-alignment" (click)="addTestReport()">
                {{submittalLbl.addTestReportLbl?submittalLbl.addTestReportLbl:testReport.addTestReportLbl}}
              </button>
            </div>           
          </div>
          <br />
          <section class="m-10">
            <kendo-grid [data]="testReportGridView"
                        [height]="470"
                        [sortable]="true"
                        [navigable]="true"
                        [filterable]="true"
                        [groupable]="false"
                        [reorderable]="true"
                        [resizable]="false"
                        [sort]="testReportGridstate.sort"
                        (sortChange)="testReportGridSortChange($event)"
                        [pageable]="{ buttonCount: 5, info: true }"
                        [pageSize]="testReportGridstate.take"
                        [skip]="testReportGridstate.skip"
                        [columnMenu]="false"
                        (pageChange)="testReportGridPageChange($event)"
                        (dataStateChange)="testReportDataStateChange($event)"
                        [filter]="testReportGridstate.filter">

              <kendo-grid-column field="reportNumber"
                                 title="{{submittalLbl.testReportNoLbl?submittalLbl.testReportNoLbl:testReport.testReportNoLbl}}"
                                 [filterable]="true" [width]="200">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="productOptTested"
                                 title="{{submittalLbl.testReportDescLbl?submittalLbl.testReportDescLbl:testReport.testReportDescLbl}}"
                                 [filterable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-command-column [width]="80"
                                         [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                  <button class="k-button k-grid-remove-command " (click)="deleteTestReport(rowIndex)">
                    <span class="k-icon k-i-trash">
                    </span>
                  </button>
                </ng-template>
              </kendo-grid-command-column>
              <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                <kendo-pager-info></kendo-pager-info>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
                <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
              </ng-template>
            </kendo-grid>
          </section>
          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="testReportContinue()">
              {{submittalLbl.continueLbl?submittalLbl.continueLbl:continueLbl}}
            </button>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item  title="{{submittalLbl.generateSubmittalPanelLbl?submittalLbl.generateSubmittalPanelLbl:generateSubmittal.generateSubmittalPanelLbl}}"
                         [expanded]="false">

      <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
              <div class="col-xs-12 col-sm-12 m-top">
                <div class="form-group">
                  <label class="lbl">
                    {{submittalLbl.companyContactNameLbl?submittalLbl.companyContactNameLbl:generateSubmittal.companyContactNameLbl}}
                  </label>
                  <input type="text" kendoTextBox [(ngModel)]="generateSubmittalData.companyContactName"
                         class="kendoInput" />
                </div>
                <div class="form-group">
                  <p><strong>
  {{submittalLbl.kanweerTermsConditionsLbl?submittalLbl.kanweerTermsConditionsLbl:generateSubmittal.kanweerTermsConditionsLbl}}
</strong></p>
                  <span>{{submittalLbl.termsAndConditionsPart1?submittalLbl.termsAndConditionsPart1:generateSubmittal.termsAndConditionsPart1}}</span>
                </div>
                <div class="form-group">
                  <kendo-switch [(ngModel)]="generateSubmittalData.termsChecked" name="toggle" onLabel="Yes" offLabel="No">
                  </kendo-switch>
                  <label [for]="termsConditions" class="lblCheck">
                    {{submittalLbl.termsConditionsLbl?submittalLbl.termsConditionsLbl:generateSubmittal.termsConditionsLbl}}
                  </label>
                  </div>
                  <div class="button-align" *ngIf="generateSubmittalData.termsChecked">
                    <button kendoButton class="m-3 btn btn-success"
                            (click)="downloadSubmittalPackage()" [disabled]="saveInProcess">
                      {{submittalLbl.downloadSubmittalLbl?submittalLbl.downloadSubmittalLbl:generateSubmittal.downloadSubmittalLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                    </button>
                    <!--<button kendoButton (click)="cancel()">{{submittalLbl.cancelLbl?submittalLbl.cancelLbl:generateSubmittal.cancelLbl}}</button>-->
                  </div>
                </div>
            </div>
            <div class="col-sm-3"></div>
          </div>

      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
